import { render, staticRenderFns } from "./UploadCart.vue?vue&type=template&id=0ef4a906&scoped=true&"
import script from "./UploadCart.vue?vue&type=script&lang=js&"
export * from "./UploadCart.vue?vue&type=script&lang=js&"
import style0 from "./UploadCart.vue?vue&type=style&index=0&id=0ef4a906&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef4a906",
  null
  
)

export default component.exports